import axios from '@/libs/api.request'

//   获取订单列表
export const getfoodOrderList = (data) => {
    return axios.request({
      url: 'foodorder/page',
      data: data,
      method: 'post',
    })
}

// 修改订单状态
export const updateordertype = (data) => {
    return axios.request({
      url: 'foodorder/updateordertype',
      data: data,
      method: 'post',
    })
}